// const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
// const PreviousSuperAdminID = JSON.parse(sessionStorage.getItem('PreviousSuperAdminID')) || null;
// const PreviousCompanyID = JSON.parse(sessionStorage.getItem('PreviousCompanyID')) || null;
// const PreviousSuperAdminSignInType = sessionStorage.getItem('PreviousSuperAdminSignInType');
// const storedCompanyID = signInDetails ? signInDetails[0].CompanyID : null;
// const storedCompanyCode = signInDetails ? signInDetails[0].CompanyCode : null;

// let addedByID = null; // Use consistent naming (camelCase)
// console.log(signInDetails, 'signInDetails')
// if (signInDetails && signInDetails[0]) {
//     const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
//     if (PreviousSuperAdminID) {
//         // Handle the "Switch to Client" case with PreviousSuperAdminID
//         // addedByID = signInDetails[0].CompanyID +
//         //     '-' + signInDetails[0].SignInType +
//         //     '-' + PreviousSuperAdminID;
//         addedByID = PreviousSuperAdminID + '-' + PreviousSuperAdminSignInType;
//     } else if (PreviousCompanyID) {
//         // Handle the case with PreviousCompanyID
//         addedByID = signInDetails[0].SuperAdminID +
//             '-' + signInDetails[0].SignInType +
//             '-' + PreviousCompanyID;
//     } else {
//         // Handle the default sign-in case
//         const signInType = signInDetails[0].SignInType;

//         if (signInType === "SuperAdmin") {
//             addedByID = signInDetails[0].SuperAdminID + '-' + signInDetails[0].SignInType;
//         } else if (signInType === "ClientAdmin") {
//             addedByID = signInDetails[0].CompanyID + '-' + signInDetails[0].SignInType;
//         } else if (signInType === "User") {
//             addedByID = signInDetails[0].UserID + '-' + signInDetails[0].SignInType;
//         }
//     }
// }

// export const ADDED_BY_ID = addedByID;
// export const Company_ID = storedCompanyID;
// export const Company_Code = storedCompanyCode;


// Constants.js

function calculateAddedById() {
    const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
    const PreviousSuperAdminID = JSON.parse(sessionStorage.getItem('PreviousSuperAdminID')) || null;
    const PreviousCompanyID = JSON.parse(sessionStorage.getItem('PreviousCompanyID')) || null;
    const PreviousSuperAdminSignInType = sessionStorage.getItem('PreviousSuperAdminSignInType');

    let addedByID = null;

    if (signInDetails && signInDetails[0]) {
        if (PreviousSuperAdminID) {
            // Switch to Client
            addedByID = PreviousSuperAdminID + '-' + PreviousSuperAdminSignInType;
        } else if (PreviousCompanyID) {
            // Switch back to SuperAdmin
            addedByID =
                signInDetails[0].SuperAdminID +
                '-' +
                signInDetails[0].SignInType +
                '-' +
                PreviousCompanyID;
        } else {
            // Default case
            const signInType = signInDetails[0].SignInType;
            if (signInType === 'SuperAdmin') {
                addedByID = signInDetails[0].SuperAdminID + '-' + signInType;
            } else if (signInType === 'ClientAdmin') {
                addedByID = signInDetails[0].CompanyID + '-' + signInType;
            } else if (signInType === 'User') {
                addedByID = signInDetails[0].UserID + '-' + signInType;
            }
        }
    }

    return addedByID;
}

function getCompanyID() {
    const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
    return signInDetails ? signInDetails[0].CompanyID : null;
}

function getCompanyCode() {
    const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
    return signInDetails ? signInDetails[0].CompanyCode : null;
}

// 🔹 Export with dynamic getters
Object.defineProperty(exports, 'ADDED_BY_ID', {
    get: function () {
        return calculateAddedById();
    },
});

Object.defineProperty(exports, 'Company_ID', {
    get: function () {
        return getCompanyID();
    },
});

Object.defineProperty(exports, 'Company_Code', {
    get: function () {
        return getCompanyCode();
    },
});
